import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { AmplitudeProvider } from '~/components/providers/AmplitudeEventProvider'
import { type SurveyFilterGroups } from '~/utils'

import { useMainQueryStrategyMemo } from '../hooks/useMainQuery'
import { type InputValues, resolver } from '../utils'

import { StrategyMemoEditPrompt } from './StrategyMemoEditPrompt'
import { StrategyMemoForm } from './StrategyMemoForm'

export const StrategyMemoEdit = () => {
  const strategyMemo = useMainQueryStrategyMemo()

  const methods = useForm<InputValues>({
    defaultValues: {
      surveyId: strategyMemo.surveyId,
      brandGroupId: strategyMemo.brandGroupId,
      brandId: strategyMemo.brandId,
      surveyFilter: {
        count: strategyMemo.countOfAnswers ?? undefined,
        filterGroups: (strategyMemo.customFilter?.filter ??
          []) as SurveyFilterGroups,
      },
      dataDisplayType: strategyMemo.dataDisplayType,
      title: strategyMemo.title,
      goal: strategyMemo.goal,
      strategies: strategyMemo.strategies,
    },
    resolver,
  })

  return (
    <AmplitudeProvider eventNameSuffix="_customer strategy">
      <FormProvider {...methods}>
        <StrategyMemoForm />

        <StrategyMemoEditPrompt />
      </FormProvider>
    </AmplitudeProvider>
  )
}
